import { isBrowser } from './isBrowser';
export var isNode = function isNode() {
  return !isBrowser();
};